import { render } from "./HeroiconsOutlineDocumentDuplicate.vue?vue&type=template&id=c27ba766"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDocumentDuplicate.vue"]])

export default __exports__